import { useState } from 'react';
import useConfigurationStore from '../store/configurationStore';
import { formatPrice } from '../utils/priceCalculator';

export default function OptionCard({ option }) {
    const {
        selectedOptions,
        excludedOptions,
        includedPriceOptions,
        toggleOption,
        setQuantity,
    } = useConfigurationStore();

    const [showLightbox, setShowLightbox] = useState(false);

    const config = window.astConfig || {};
    const showPrices = config.showPrices;
    const optionId = Number(option.id);
    const isSelected = !!selectedOptions[optionId];
    const isExcluded = excludedOptions.has(optionId);
    const isPriceIncluded = includedPriceOptions.has(optionId);
    const isRequired = option.is_required === '1' || option.is_required === 1;
    const quantity = selectedOptions[optionId]?.quantity || 1;

    const handleClick = () => {
        if (isExcluded) return;
        toggleOption(option);
    };

    const handleImageClick = (e) => {
        e.stopPropagation();
        setShowLightbox(true);
    };

    let className = 'ast-option-card';
    if (isSelected) className += ' ast-option-card--selected';
    if (isExcluded) className += ' ast-option-card--excluded';
    if (isRequired) className += ' ast-option-card--required';

    return (
        <>
            <div className={className} onClick={handleClick}>
                {option.image_url && (
                    <div className="ast-option-card__image">
                        <img src={option.image_url} alt={option.name} loading="lazy" />
                    </div>
                )}

                <div className="ast-option-card__content">
                    <div className="ast-option-card__header">
                        <h4 className="ast-option-card__name">{option.name}</h4>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            {option.image_url && (
                                <button
                                    className="ast-option-card__img-trigger"
                                    onClick={handleImageClick}
                                    title="Afbeelding bekijken"
                                >
                                    &#128247;
                                </button>
                            )}
                            <div className="ast-option-card__check">
                                {isSelected && <span className="ast-check">&#10003;</span>}
                            </div>
                        </div>
                    </div>

                    {option.sku && (
                        <span className="ast-option-card__sku">{option.sku}</span>
                    )}

                    {option.description && (
                        <p className="ast-option-card__desc">{option.description}</p>
                    )}

                    <div className="ast-option-card__footer">
                        {showPrices && (
                            <span className="ast-option-card__price">
                                {option.price_type === 'none' ? (
                                    null
                                ) : option.price_type === 'included' ? (
                                    <span className="ast-price-included">Inbegrepen</span>
                                ) : option.price_type === 'on_request' ? (
                                    <span className="ast-price-on-request">Op nacalculatie</span>
                                ) : isPriceIncluded ? (
                                    <span className="ast-price-included">Inbegrepen</span>
                                ) : (
                                    formatPrice(option.price)
                                )}
                            </span>
                        )}

                        {isSelected && option.price_type === 'per_unit' && (
                            <div className="ast-option-card__quantity" onClick={(e) => e.stopPropagation()}>
                                <button
                                    className="ast-qty-btn"
                                    onClick={() => setQuantity(optionId, quantity - 1)}
                                    disabled={quantity <= 1}
                                >
                                    -
                                </button>
                                <span className="ast-qty-value">{quantity}</span>
                                <button
                                    className="ast-qty-btn"
                                    onClick={() => setQuantity(optionId, quantity + 1)}
                                >
                                    +
                                </button>
                            </div>
                        )}

                        {isRequired && (
                            <span className="ast-option-card__badge ast-option-card__badge--required">
                                Verplicht
                            </span>
                        )}
                    </div>

                </div>
            </div>

            {showLightbox && option.image_url && (
                <div className="ast-lightbox" onClick={() => setShowLightbox(false)}>
                    <button className="ast-lightbox__close" onClick={() => setShowLightbox(false)}>
                        &times;
                    </button>
                    <img src={option.image_url} alt={option.name} onClick={(e) => e.stopPropagation()} />
                </div>
            )}
        </>
    );
}
